export default "__VITE_ASSET__CY8fZUeh__"